import { render, staticRenderFns } from "./samecityMasterlistAdd.vue?vue&type=template&id=bad499ee&scoped=true"
import script from "./samecityMasterlistAdd.vue?vue&type=script&lang=js"
export * from "./samecityMasterlistAdd.vue?vue&type=script&lang=js"
import style0 from "./samecityMasterlistAdd.vue?vue&type=style&index=0&id=bad499ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad499ee",
  null
  
)

export default component.exports